import React from "react";
import "../styles/Footer.css";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} DoinaRo28 - Todos los derechos reservados</p>
      <p ><Link className="foo" to="/terminos">Términos y Condiciones</Link></p>
      <div className="footer-socials">
        <a href="https://www.facebook.com/DoinaRo.el.28/" target="_blank" rel="noopener noreferrer" title="Facebook">
          <FaFacebookF />
        </a>
        <a href="https://www.instagram.com/doinaro_28/" target="_blank" rel="noopener noreferrer" title="Instagram">
          <FaInstagram />
        </a>
        <a href="https://www.youtube.com/@doinaro28" target="_blank" rel="noopener noreferrer" title="YouTube">
          <FaYoutube />
        </a>
        <a href="https://www.tiktok.com/@doina.ro.28" target="_blank" rel="noopener noreferrer" title="TikTok">
          <FaTiktok />
        </a>
      </div>
    </footer>
  );
};

export default Footer;